import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DocumentManagementService } from '../services/document-management.service';
import { OnBaseDocumentTypeProcessReference, OnBaseProcessName } from '../models/onBaseIntegrationAndMapping.model';
import { LoaderService } from '../services/loader.service';

export function onBaseDocumentTypesByProcessResolver(processName: OnBaseProcessName): ResolveFn<OnBaseDocumentTypeProcessReference[]> {
    return (route: ActivatedRouteSnapshot): Observable<OnBaseDocumentTypeProcessReference[]> => {
        const documentManagementService = inject(DocumentManagementService);
        const loaderService = inject(LoaderService);

        loaderService.toggleLoader(true);

        return documentManagementService.getOnBaseDocumentTypesByProcessName(processName).pipe(
            catchError((error) => {
                console.error(error);
                loaderService.toggleLoader(false);
                return of([] as OnBaseDocumentTypeProcessReference[]);
            }),
            tap(() => loaderService.toggleLoader(false))
        );
    };
}
